import { FilterViewModel } from '../regulation';

export class SelfAssessmentDetailsDD {
    ruleApplicable: Array<string>;
    assessor: Array<FilterViewModel>;
    assessorDelegate: Array<FilterViewModel>;
    assessmentStatus: Array<string>;
    overallStatus: Array<string>;
    ruleConclusion: Array<string>;
    reviewer: Array<FilterViewModel>;
    reviewerDelegate: Array<FilterViewModel>;
    reviewStatus: Array<string>;
    gapReviewStatus: Array<string>;
    actionOwner: Array<FilterViewModel>;
    enhancementActionOwner: Array<FilterViewModel>;
    actionStatus: Array<string>;

    constructor() {
        this.ruleApplicable = [];
        this.assessor = [];
        this.assessorDelegate = [];
        this.assessmentStatus = [];
        this.overallStatus = [];
        this.ruleConclusion = [];
        this.reviewer = [];
        this.reviewerDelegate = [];
        this.reviewStatus = [];
        this.gapReviewStatus = [];
        this.actionOwner = [];
        this.enhancementActionOwner = [];
        this.actionStatus = [];
    }
}

export class SelfAssessmentAllDropdownList {
    ruleApplicable: Array<string>;
    assessmentStatus: Array<string>;
    reviewStatus: Array<string>;
    overallStatus: Array<string>;
    ruleConclusion: Array<string>;
    
    gapReviewStatus: Array<string>;
    actionStatus: Array<string>;
    enhancementReviewStatus: Array<string>;
    enhancementActionStatus: Array<string>;

    constructor() {
        this.ruleApplicable = [];
        this.assessmentStatus = [];
        this.overallStatus = [];
        this.ruleConclusion = [];
        this.reviewStatus = [];
        this.gapReviewStatus = [];
        this.actionStatus = [];
        this.enhancementReviewStatus = [];
        this.enhancementActionStatus = [];
    }
}

export class SelfAssessmentT2DetailsDD {
    //New Field
    assessmentCategory: Array<string>;
    assessmentTeam: Array<string>;
    assessmentStatus: Array<string>;
    complianceStatus: Array<string>;
    interpretation: Array<string>;
    judgement: Array<string>;
    gaps: Array<string>;
    enhancement: Array<string>;
    riskRecommendation: Array<string>;
    riskRecommendationStatus: Array<string>;
    reviewerTeam: Array<string>;
    reviewStatus: Array<string>;
    approvalTeam: Array<string>;
    approvalStatus: Array<string>;

    //Name Field
    assessor: Array<FilterViewModel>;
    approver: Array<FilterViewModel>;
    reviewer: Array<FilterViewModel>;

    constructor() {
        this.assessor = [];
        this.approver = [];
        this.reviewer = [];
        this.assessmentCategory = [];
        this.assessmentTeam = [];
        this.assessmentStatus = [];
        this.complianceStatus = [];
        this.interpretation = [];
        this.gaps = [];
        this.judgement = [];
        this.enhancement = [];
        this.riskRecommendation = [];
        this.riskRecommendationStatus = [];
        this.reviewerTeam = [];
        this.reviewStatus = [];
        this.approvalTeam = [];
        this.approvalStatus = [];
    }
}

export class SelfAssessmentT2AllDropdownList {
    assessmentCategory: Array<string>;
    assessmentTeam: Array<string>;
    assessmentStatus: Array<string>;
    complianceStatus: Array<string>;
    interpretation: Array<string>;
    judgement: Array<string>;
    gaps: Array<string>;
    enhancement: Array<string>;
    riskRecommendation: Array<string>;
    riskRecommendationStatus: Array<string>;
    reviewerTeam: Array<string>;
    reviewStatus: Array<string>;
    approvalTeam: Array<string>;
    approvalStatus: Array<string>;

    constructor() {
        this.assessmentCategory = [];
        this.assessmentTeam = [];
        this.assessmentStatus = [];
        this.complianceStatus = [];
        this.interpretation = [];
        this.gaps = [];
        this.judgement = [];
        this.enhancement = [];
        this.riskRecommendation = [];
        this.riskRecommendationStatus = [];
        this.reviewerTeam = [];
        this.reviewStatus = [];
        this.approvalTeam = [];
        this.approvalStatus = [];
    }
}